const $ = jQuery.noConflict();
class SliderQuotes {
    constructor(quoteSlider) {
        this.quoteSlider = quoteSlider;
    }
    init() {
        this.initSlider();
    }
    initSlider() {
        $(this.quoteSlider).slick ({
            slidesToShow: this.slideNo,
            dots: false,
            infinite: true,
            speed: 0,
            cssEase: 'linear',
            swipe: false
        });

        $(this.quoteSlider).on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $('.slick-slide').eq(currentSlide).addClass('opacity-off');
        });
        $(this.quoteSlider).on('afterChange', function(event, slick, currentSlide, nextSlide){
            $('.slick-slide').removeClass('opacity-off');
        });
    }
}

export default new SliderQuotes('.quote-slider');